<template>
  <el-table
    :element-loading-text="config.loadtext"
    :data="tableData"
    border
    stripe
    :height="config.height"
    :max-height="config.maxHeight"
    highlight-current-row
    style="width: 100%; overflow-y: auto;"
    :header-cell-style="{background:'#F8FCFF',color:'#606266'}"
    size="mini"
  >
    <el-table-column
      v-for="item in tableLabel"
      v-if="!(item.isShow || item.isShow === 'false')"
      :key="item.prop"
      :sortable="item.sortable"
      :label="item.label"
      :fixed="item.fixed"
      :width="item.width ? item.width : ''"
      :align="item.aligin ? item.aligin : 'center'"
      header-align="center"
      show-overflow-tooltip
    >
      <!-- eslint-disable-next-line -->
      <template  slot="header" slot-scope="scope">
        <div style="line-height: 14px;"> {{ item.label }}</div>
        <div v-if="config.searchTables">
          <el-divider></el-divider>
          <el-date-picker
            v-if="item.type === 'Date'"
            v-model="item.search"
            size="mini"
            clearable
            type="daterange"
            align="left"
            unlink-panels
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
            style="width:100%"
            format="yyyy 年 MM 月 dd 日"
            value-format="yyyy-MM-dd"
            @change="dateChangeEvent">
          </el-date-picker>
          <el-input
            v-else
            v-model="item.search"
            size="mini"
            clearable
            prefix-icon="el-icon-search"
            style="line-height: 24px;"
            @keyup.enter.native="searchTable()"></el-input>
        </div>
      </template>
      <template slot-scope="scope">
        <el-link v-if="item.click" type="primary">{{ scope.row[item.prop] }}</el-link>
        <span v-else style="text-align: center;">{{ scope.row[item.prop] }}</span>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
export default {
  props: {
    tableLabel: Array,
    tableData: Array
  },
  name: 'tableTemplate',
  data() {
    return {
      config: {
        fixed: true,
        sizes: [15, 25, 35],
        dataTotalCount: 0,
        pageSize: 15,
        currentPage: 1
      }
    }
  }
}
</script>

<style scoped>

</style>
